<script lang="ts">
    import type {DirectoryNode} from 'src/typings';
    import OverviewDirectory from './OverviewDirectory.svelte';

    export let rootDirectory: DirectoryNode;
    export let selectedDirectory: DirectoryNode | null;
</script>

<OverviewDirectory directoryNode={rootDirectory}
                   level={1}
                   {selectedDirectory}
                   on:directory-select/>